import React from 'react';
import './PrivacyPopup.css';

function PrivacyPopup() {
  return (
    <div className="privacy-popup-content" style={{ padding: '30px', fontFamily: 'sans-serif', lineHeight: '1.6', maxWidth: '800px', margin: '0 auto' }}>
      <h1>에이콘온 이용약관</h1>

      <h2>1. 서비스 이용약관 (필수)</h2>

      <h3>제1조 (목적)</h3>
      <p>
        이 약관은 주식회사 에이콘온(이하 "회사")이 운영하는 저자 맞춤형 출판 플랫폼 ‘에이콘온(www.acornon.kr)’의 서비스의 이용과 관련하여, 회사와 회원 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 정하는 것을 목적으로 합니다.
      </p>

      <h3>제2조 (용어의 정의)</h3>
      <p>이 약관에서 사용하는 주요 용어의 정의는 다음과 같습니다.</p>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        <li>1. 회사: ‘에이콘온(www.acornon.kr)’ 플랫폼을 운영하며, 출판 및 출판 관련 서비스를 제공하는 사업자를 말합니다.</li>
        <li>2. 회원: 회사의 플랫폼에 접속하여 본 약관에 동의하고, 회원가입 절차를 완료한 개인 또는 단체를 말합니다.</li>
        <li>3. 비회원: 회사의 플랫폼에 가입하지 않고도 회사가 제공하는 서비스를 이용하는 개인 또는 단체를 말합니다.</li>
        <li>4. 서비스: 회사가 플랫폼을 통해 제공하는 온라인 및 오프라인 활동 전반을 총칭하며, 출판 기획, 제안서 접수, 맞춤 상담, 콘텐츠 제공 등을 포함합니다.</li>
        <li>5. 게시물: 회원이 서비스를 이용하면서 작성, 업로드, 등록한 글, 이미지, 문서, 파일 등 모든 형태의 콘텐츠를 의미합니다.</li>
        <li>6. 계약서: 출판 진행 시 체결되는 프로젝트 계약을 의미하며, 본 약관과 함께 적용됩니다.</li>
        <li>7. 이외에 이 약관에서 사용하는 용어의 정의는 관계 법령 및 서비스 별 안내에서 정하는 바에 의합니다.</li>
      </ul>

      <h3>제3조 (서비스 제공 내용)</h3>
      <p>1. 회사는 아래와 같은 서비스를 제공합니다.</p>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        <li>① 저자 맞춤형 출판 서비스 제공 (자비 출판 대행, 반기획 출판, 기획 출판, 아마존 출판 대행)</li>
        <li>② 1:1 기획, 편집, 마케팅 상담</li>
        <li>③ 출판 제안서·기획안 접수 및 소통 지원</li>
        <li>④ 콘텐츠 제작 및 유통 채널 정보 제공</li>
        <li>⑤ 출판 계약 체결 이후의 진행 및 관리</li>
        <li>⑥ 기타 ‘서비스’에서 정하는 업무</li>
      </ul>
      <p>2. 단, 무료로 제공되는 서비스에 대해서는 관련 법에 특별한 규정이 없는 한 손해배상 책임을 지지 않습니다.</p>

      <h3>제4조 (회원가입 및 자격)</h3>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        <li>1. 회원은 만 14세 이상으로, 본인의 실명과 정확한 정보를 사용해 가입해야 합니다.</li>
        <li>2. 회사는 본인확인 또는 인증 절차를 요청할 수 있으며, 이를 거부하거나 허위 정보를 기재할 경우 가입이 제한될 수 있습니다.</li>
        <li>3. 회사는 다음과 같은 사유가 있는 경우 회원 가입을 거부하거나, 기 등록된 회원의 자격을 제한·정지 또는 박탈할 수 있습니다.
          <ul style={{ listStyleType: 'none', paddingLeft: '20px' }}>
            <li>① 실명이 아닌 경우 또는 타인 명의 사용</li>
            <li>② 허위 정보 등록</li>
            <li>③ 서비스 운영을 고의로 방해하는 행위</li>
          </ul>
        </li>
      </ul>

      <h3>제5조 (서비스 변경 및 중단)</h3>
      <p>1. 회사는 서비스의 일부 또는 전부를 변경하거나 종료할 수 있으며, 이 경우 회원에게 이메일, 공지사항 게시 또는 서비스 내 알림등을 통해 사전에 공지합니다.</p>
      <p>2. 단, 계약이 체결된 출판 프로젝트와 관련된 변경 사항은 개별 계약서의 조건에 따릅니다.</p>

      <h3>제6조 (회원 탈퇴 및 계약 해지)</h3>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        <li>1. 회원은 언제든지 마이페이지 또는 고객센터를 통해 회원 탈퇴를 요청할 수 있습니다.</li>
        <li>2. 회사는 관련 법령 또는 계약서 조건에 따라 회원 정보를 일정 기간 보유하거나 삭제할 수 있습니다.</li>
        <li>3. 출판 계약이 체결된 경우, 탈퇴 또는 해지와 관련한 사항은 출판 계약서의 조건에 따릅니다.</li>
      </ul>

      <h3>제7조 (이용 제한 및 조치)</h3>
      <p>회사는 다음 사유가 발생할 경우 사전 통지 없이 회원의 서비스 이용을 제한하거나 회원 자격을 정지시킬 수 있습니다.</p>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        <li>1. 저작권 등 타인의 권리를 침해하거나 불법 행위가 명백한 경우</li>
        <li>2. 게시판 또는 플랫폼 운영 질서를 해치는 행위</li>
        <li>3. 서비스 내 스팸, 욕설, 비방 등 악의적 활동</li>
        <li>4. 1년이상 미접속 등 장기 비활성계정에 대한 조치</li>
      </ul>

      <h3>제8조 (준거법 및 재판관할)</h3>
      <p>1. "회사"와 "회원" 간 제기된 소송은 대한민국법을 준거법으로 합니다.</p>
      <p>2. "회사"와 "회원"간 발생한 분쟁에 관한 소송은 서울중앙지방법원을 관할법원으로 합니다.</p>

      <p><strong>[부칙]</strong> 이 약관은 2025년 7월 1일부터 적용됩니다.</p>

      <h2>2. 개인정보 수집 및 이용 동의 (필수)</h2>
      <p>회사는 회원가입 및 출판 제안, 맞춤형 상담, 유통 안내 등을 위해 아래 정보를 수집합니다.</p>
      <p><strong>• 수집 항목:</strong> 이름, 이메일, 비밀번호, 연락처(휴대폰), 관심 출판유형, 출간 희망 분야</p>
      <p><strong>• 보유 기간:</strong> 회원 탈퇴 또는 수집 목적 달성 시 지체 없이 삭제 (단, 관련 법령에 따라 예외 보관 가능)</p>

      <h2>3. 개인정보 처리 위탁 동의 (필수)</h2>
      <p>회사는 서비스 운영을 위해 아래와 같이 외부 전문 업체에 일부 업무를 위탁할 수 있습니다.</p>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        <li>• Amazon Web Services (AWS): 서버 및 데이터 저장</li>
        <li>• 카카오: 알림톡 발송, 카카오톡 챗봇 연동</li>
        <li>• 기타 계약된 파트너사: 출판 및 편집 업무 위탁 시 별도 고지 예정</li>
      </ul>

      <h2>4. 제3자 정보 제공 동의 (선택)</h2>
      <p>회사는 회원의 동의가 있는 경우, 출판 매칭 및 제안 목적에 한해 아래와 같이 정보를 제공할 수 있습니다.</p>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        <li>• 제공 항목: 이름, 출간 희망 분야, 연락처, 기획 내용 일부</li>
        <li>• 제공받는 자: 협력 출판사, 외부 편집자, 유통 파트너 등</li>
        <li>• 보유 및 이용 기간: 제공 목적 달성 시까지</li>
      </ul>
      <p><strong>※ 동의하지 않아도 회원가입 및 기본 서비스 이용은 가능하나, 출판 제안 추천 기능은 제한될 수 있습니다.</strong></p>

      <h2>5. 마케팅 정보 수신 동의 (선택)</h2>
      <p>에이콘온은 유익한 출판 기획 정보, 출판 제안, 콘텐츠 정보, 기획 공모 안내, 뉴스레터 등의 정보를 문자 또는 이메일로 제공할 수 있습니다.</p>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        <li>• 발송 채널: 이메일, 문자(SMS), 알림톡</li>
        <li><strong>※ 수신 동의 여부는 마이페이지에서 언제든 변경할 수 있습니다.</strong></li>
      </ul>
    </div>
  );
}

export default PrivacyPopup;
